//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { apiUrl } from '@/config/env'
  import { mapState } from 'vuex'
import {  getStore, GetPickList, PutPickRemark, GetDiskVerifyByStore, PutBindPickDisk } from './../../service/index';
import { go } from './../../util/router';
export default {
  name: 'hello',
  data() {
    return {
      apiUrl: apiUrl.replace('/api',''),
      PickList: [],
      pageIndex: 0,
      pageSize: 10,
      pageCount: 0,
      isLock: false,
      noMore: false,
      otype: '' ,// 现货抢购|现货选配|其他
      StoreInfo: {},
      panid: '', //挑货盘编号
      Oid: '', //挑货盘ID
      isBindPan: false, //绑定挑货盘ID？
      curNumber: '' ,//绑定挑货盘的单据编号
      PickListId: '',//绑定挑货盘的单据Id
      PickListNumber: '',
      titMsg: '',
      bind_P: ''
    };
  },
  components: {},
  created() {
    this.GetPickList();
    getStore(null, (result) => {
      if (result.code === '1') {
        let user = JSON.parse(result.data)
        console.log(user)
        this.StoreInfo = user
        // setItem('ZDS_Store', {name: String(user.FSHOP_STATUS).substring(0, 2)})
      }
    })
  },
  mounted() {
    this.pagescroll();
    console.log(55555566666666,this.$route.query.p)
    this.panid = this.$route.query.p
    if(this.panid){
      this.isBindPan = true
      localStorage.setItem('_P',this.panid)
      // 跳转携带盘号
      let _P = localStorage.getItem('_P')
      if(_P){
        this.bind_P = '?p='+_P
      }
      // 验证盘号是否可以被当前用户绑定
      this.GetDiskVerifyByStore();
    }else{
      this.isBindPan = false
      localStorage.removeItem('_P')
    }
  },
  watch: {
    $route: function(to, from) {
      console.log(555)
      let vm = this;
      if (to.name === 'picklist' && (from.name === 'home1'||from.name === 'home'||from.name === 'shopcart'||from.name === 'order')) {
        vm.pageIndex = 0;
        vm.pageCount = 0;
        vm.PickList = [];
        vm.GetPickList();
      }
    }
  },
  methods: {
    Edit(item){
      item.edit = true
    },
    Ccheck (item) {
      this.curNumber = item.Number
      this.PickListId = item.Oid
      console.log(this.curNumber)
      // itemf.isCheckAll = !itemf.ProList.filter(c => c.cur === false).length > 0
      // this.Calcul()
    },
    Save(item){
      // if(!item.Remark){
      //   this.showToast('请填写备注信息!')
      //   return
      // }
      PutPickRemark({
        Oid: item.Oid,
        Remark: item.Remark
      },result=>{
        if (result.code === '1') {
          let ls = JSON.parse(result.data);
          if (ls.IsSuccess) {
            this.showToast('修改成功!')
            item.edit = false
          }else{
            this.showToast('修改失败!')
          }
        }
      })
    },
    GetPickList() {
      let vm = this;
      let pData = {
        pageNum: vm.pageIndex,
        pageSize: vm.pageSize
      };
      vm.isLock = true;
      GetPickList(pData, result => {
        vm.isLock = false;
        // console.log(JSON.parse(result.data));
        if (result.code === '1') {
          let ls = JSON.parse(result.data);
          console.log(ls)
          if(ls.TotalCount == 0){

          }else{
            for (let item of ls.List) {
              // console.log(item)
              // console.log(JSON.parse(JSON.stringify(item)))
              item = JSON.parse(JSON.stringify(item))
              item.edit = false
              // item.cur = false
              vm.PickList.push(item);
              this.$previewRefresh()
            }
          }

          if (ls.length < vm.pageSize) {
            vm.noMore = true;
          }
        }
        if(result.msg == '由于网络不稳定或长时间未操作，请重新登录！'){
          // console.log(this.$route.fullPath)
          this.$router.push({
            path: '/login',
            query: { redirect: this.$route.fullPath } ,
          });
        }
      });
    },
    doDetail(oid) {
      // this.$router.push({ path: '/picklistdetail/' + oid}) // 现货选配
      go('/picklistdetail/' + oid, this.$router)
    },
    pagescroll() {
      let self = this;
      window.onscroll = function() {
        let body = document.body;
        let scrollTop = body.scrollTop === 0 ? document.documentElement.scrollTop : body.scrollTop;
        let dHeight = body.scrollHeight;
        let height = document.documentElement.clientHeight;
        // console.log(scrollTop + '|' + dHeight + '｜' + height)
        // console.log((scrollTop + height), dHeight)
        if (scrollTop + height >= dHeight - 100) {
          // console.log(self.pageCount, self.pageIndex, self.pageSize)
          if (!self.isLock && !self.noMore) {
            self.isLock = true;
            self.pageIndex += 1;
            self.GetPickList();
          }
        }
      };
    },
    // 取消绑定
    CancelBindPan(){
      localStorage.removeItem('_P')
      this.isBindPan = false
      this.$router.replace({
        path: '/picklist'
      });
    },
    // 绑定挑货盘
    BindPan(){
      // GetDiskVerifyByStore, PutBindPickDisk
      console.log(this.panid,this.curNumber)
      if(!this.curNumber){
        this.showToast('请选择单据编号!')
        return
      }
      this.showConfirm(
        `<p>挑货盘号：${this.panid}</p><p>单据编号：${this.curNumber}</p>`, null,
        () => {
          console.log('调用绑定挑货盘接口')
          PutBindPickDisk({
            Oid: this.Oid,
            PickListId:this.PickListId
          }, result => {
            console.log(JSON.parse(result.data));
            let data = JSON.parse(result.data)
            if (result.code === '1' && data.IsSuccess) {
              this.showToast('绑定成功!')
              localStorage.removeItem('_P')
              this.PickListNumber = ''
              this.$router.replace({
                path: '/picklist'
              });
              this.isBindPan = false
              // this.GetDiskVerifyByStore();
            }else{
              this.showToast('绑定失败! Err:'+data.Msg)
            }
          });
        }
      )
    },
    GetDiskVerifyByStore(){
      console.log(9999988888)
      // 验证盘号是否可以被当前用户绑定
      GetDiskVerifyByStore(this.panid, result => {
        console.log(result);

        let data = JSON.parse(result.data)
        console.log(data);
        if (result.code === '1') {
          if(data.IsVerify){
            this.Oid = data.Data.Oid
            this.PickListNumber = data.Data.PickList
          }else{
            this.showAlert(data.Msg)
            this.titMsg = data.Msg
          }
        }else{
          this.showToast(result.msg)
        }
      });
    }
  },
  computed: {
    ...mapState({
      route: state => state.route,
      path: state => state.route.path
    })
  }
};



// WEBPACK FOOTER //
// ./src/page/picklist/index.vue